export default "__VITE_ASSET__CqppQJm0__"